module.exports = __webpack_public_path__ + "static/media/game_cover_wd.ade27107.png";